// src/pages/dashboard/BotsPanel.tsx
import React, { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { config } from "../../config";

export default function BotsPanel() {
  const [bots, setBots] = useState<any[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState("");

  useEffect(() => {
    const fetchBots = async () => {
      try {
        const res = await fetch(`${config.apiBase}/bots`);
        if (res.ok) {
          const data = await res.json();
          setBots(data || []);
        } else {
          throw new Error('Failed to fetch bots');
        }
      } catch (err) {
        console.error("Failed to fetch bots:", err);
        setError("Failed to load bots");
      } finally {
        setLoading(false);
      }
    };
    fetchBots();
  }, []);

  const toggleActive = async (bot: any) => {
    alert(`Toggle not implemented. Bot: ${bot.name}`);
  };

  const remove = async (bot: any) => {
    alert(`Delete not implemented. Bot: ${bot.name}`);
  };

  return (
    <div className="space-y-4">
      {loading && <p>Loading bots...</p>}
      {error && <p className="text-red-500">{error}</p>}
      {!loading && bots.length === 0 && <p>No bots found.</p>}
      {bots.map(bot => (
        <div key={bot.id} className="border p-4 rounded shadow flex justify-between items-center">
          <div>
            <h3 className="font-bold">{bot.name}</h3>
            <p>Strategy: {bot.strategy} | Mode: {bot.mode} | Status: {bot.active ? "Active" : "Paused"}</p>
          </div>
          <div className="flex space-x-2">
            <button onClick={() => toggleActive(bot)} className="bg-yellow-500 text-white px-3 py-1 rounded">Toggle</button>
            <button onClick={() => remove(bot)} className="bg-red-600 text-white px-3 py-1 rounded">Delete</button>
            <button onClick={() => alert("Testing bot...")} className="bg-blue-600 text-white px-3 py-1 rounded">Test</button>
          </div>
        </div>
      ))}
    </div>
  );
}

